/**
 * Intestazione societaria del titolare del servizio Virtual Clinic.
 * Fonte unica per footer, pagine legali, JSON-LD e contatti pubblici.
 */
export const COMPANY = {
  brandName: 'Virtual Clinic',
  legalName: 'Casa di Cura San Paolo',
  legalForm: 'Società per Azioni',
  /** Nome completo da usare nei testi legali */
  legalNameFull: 'Casa di Cura San Paolo Società per Azioni',
  /** Forma abbreviata (S.p.A.) */
  legalNameShort: 'Casa di Cura San Paolo S.p.A.',
  streetAddress: 'Via Bonellina 199',
  postalCode: '51100',
  city: 'Pistoia',
  region: 'Toscana',
  addressRegionCode: 'PT',
  country: 'IT',
  vatNumber: '06640750482',
  email: 'info@casadicurasanpaolo.it',
  phones: ['0573 380481', '0573 381518'],
};

export const COMPANY_ADDRESS_LINE =
  `${COMPANY.streetAddress}, ${COMPANY.postalCode} ${COMPANY.city} – ${COMPANY.region}`;

export const COMPANY_COPYRIGHT =
  `P.IVA ${COMPANY.vatNumber}. All Rights Reserved`;

export const COMPANY_MAILTO = `mailto:${COMPANY.email}`;
